import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

// Define the styles using makeStyles
const useStyles = makeStyles((theme) => ({
    stack: {
        display: 'flex',
        flexDirection: 'column',
        width: '99%',
        position: 'relative',
        left: '50%',
        transform: 'translateX(-50%)',
        marginTop: '12px',
        zIndex: 1300,  // Ensures alert is above other elements
    },
}));

const ShowAlert = (props) => {
    // Get the styles from the hook
    const classes = useStyles();



    return props.open ? (
        <Stack className={classes.stack} spacing={2}>
            <Alert severity={props.severity}>
                {props.message}
            </Alert>
        </Stack>
    ) : null;
};

// Page Feedback component interface definition
ShowAlert.propTypes = {
    open: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
    severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']).isRequired,
    autoHideDuration: PropTypes.number,
};

ShowAlert.defaultProps = {
    open: false,
    autoHideDuration: 3000,  // Default duration is 3 seconds
};

export default ShowAlert;
